import React from 'react'

import i18n from 'Pods/Shared/I18n'

import landingBanner from 'images/coupons/banner.png'

import Accordion from './Components/Accordion/Accordion'
import Banner from './Components/Banner'
import CouponCard from './Components/CouponCard'
import { couponsList } from './Static/coupons'
import { faqContent } from './Static/faq'

function Coupons() {
  const currentYear = new Date().getFullYear()
  const title = i18n.t('coupons.bannerTitle', { ns: 'rails' }).replace('%{year}', currentYear)

  return (
    <div className="coupons">
      <Banner
        title={title}
        subtitle={i18n.t('coupons.bannerSubtitle', { ns: 'rails' })}
        image={landingBanner}
      />

      <div className="container-fixed coupons-content">
        <h2 className="coupons-content__title cgt-legacy-heading-h2">
          {i18n.t('coupons.title', { ns: 'rails' })}
        </h2>

        <div className="coupons-content__list">
          {couponsList.map((coupon, index) => (
            <CouponCard {...coupon} key={`${coupon.title}-${index}`} />
          ))}
        </div>

        <h2 className="coupons-content__title cgt-legacy-heading-h2">
          {i18n.t('coupons.faq', { ns: 'rails' })}
        </h2>

        <div className="coupons-content__accordion">
          <Accordion items={faqContent} />
        </div>
      </div>
    </div>
  )
}

export default Coupons
